import {
  downloadFlightInvoice
} from "./chunk-IU2M4I7O.mjs";

// src/hooks/wbk/flights/invoice.ts
import { useMutation } from "@tanstack/react-query";
var useDownloadInvoice = () => {
  return useMutation({
    mutationFn: downloadFlightInvoice
  });
};

export {
  useDownloadInvoice
};
//# sourceMappingURL=chunk-Y3PRL2DD.mjs.map